import { Input, Button, Alert, Checkbox, Row, Col, Spin, Divider } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  confirmLogin,
  initiateGsisLogin,
  setRememberMe,
} from '../../../store/user/actions';
import { useNavigate, Link } from 'react-router-dom';
import { TextField } from 'components';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState(false);
  const { rememberMe } = useSelector(state => state.user);
  const [checked, setChecked] = useState(rememberMe);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locales = useSelector(state => state.forms?.localeStrings);
  const isLoadingLocales = useSelector(state => state.forms?.loadingLocales);
  const inputRef = useRef(null);
  const { hasError, hasInfo, loading, message, gsisAuthUrl } = useSelector(
    state => state.forms.appConfig
  );
  const [open, setOpen] = useState(false);

  // useEffect(() => {
  //   const storedLanguage =
  //     localStorage.getItem('appLanguage') ||
  //     process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
  //   dispatch(getSystemLocales(storedLanguage));
  // }, []);

  useEffect(() => {
    // Sync local checked state with Redux rememberMe state
    setChecked(rememberMe);
  }, [rememberMe]);

  const onRememberMeChange = e => {
    dispatch(setRememberMe(e.target.checked));
  };

  const authProviderSubmitClicked = () => {
    dispatch(initiateGsisLogin(gsisAuthUrl));
  };

  const logingcall = () => {
    const payload = {
      j_username: email,
      j_password: password,
      _spring_security_remember_me: checked,
      submit: 'login',
    };

    dispatch(
      confirmLogin(payload, navigate, check => {
        setLoginError(check);
      })
    );
  };

  const handleSubmit = async e => {
    e.preventDefault();
    logingcall();
  };

  return (
    <div className="main-wrapper login-page-wrapper">
      <div className="login-page-card">
        <div id="login-pape-card-title" className="login-pape-card-title">
          Είσοδος
        </div>

        <div className="mt-2">
          <label id="labelEmail" className="login-pape-card-label">
            Email
          </label>
          <TextField
            className="login-pape-card-input-component"
            containerClassName="login-pape-card-input-container"
            fieldName="username"
            fieldType="text"
            // size="large"
            id="inputUsername"
            placeholder={'username'}
            disabled={loading}
            customRef={inputRef}
            onPressEnter={handleSubmit}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div className="mt-2">
          <label id="labelPassword" className="login-pape-card-label">
            Κωδικός Πρόσβασης
          </label>
          <Input
            id="inputPassword"
            className={
              loginError
                ? 'error login-pape-card-input-component'
                : 'login-pape-card-input-component'
            }
            containerClassName="login-pape-card-input-container"
            size="large"
            type="password"
            placeholder={'password'}
            onChange={e => setPassword(e.target.value)}
            onPressEnter={handleSubmit}
            value={password}
            autoComplete="new-password"
            style={{
              marginTop: '10px',
              maxwidth: '100%',
            }}
          />
          {loginError && (
            <p className={'mt-1'} style={{ color: 'red', fontSize: '12px' }}>
              Μη έγκυρο email ή κωδικός, παρακαλώ προσπαθήστε ξανά.
            </p>
          )}
        </div>

        <div
          className={'mt-2'}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Checkbox
            className="custom-remember-checkbox"
            checked={rememberMe}
            onChange={onRememberMeChange}
            labelClassName="custom-remember-label"
            id="inputRememberMe"
          >
            Να με θυμάσαι
          </Checkbox>
          <Link
            to="/forgot-password"
            className="forgotpass-component"
            id="inputForgotPassword"
          >
            Ξέχασα τον κωδικό μου
          </Link>
        </div>

        {process.env.REACT_APP_LOGIN_TO_PLATFORM === 'true' && (
          <button
            type="primary"
            className="submit-login mt-3"
            disabled={loading}
            onClick={handleSubmit}
            id="inputEnter"
          >
            Είσοδος
          </button>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
